import { render } from "./SurveyQ6.vue?vue&type=template&id=f6298e3e&ts=true"
import script from "./SurveyQ6.vue?vue&type=script&lang=ts"
export * from "./SurveyQ6.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__